// extracted by mini-css-extract-plugin
export default {"container":"QAGroup_container__Zu0R5","header":"QAGroup_header__Gc6Pg","desc":"QAGroup_desc__hiwE5"};